import type { State } from './reducer'
import type { ActionsNetwork } from 'shared/store/actions'
import { fetchPageData } from 'shared/store/actions'
import endpoints from 'shared/store/endpoints'
import { ws } from 'shared/store/ws'
import type { Dispatch } from 'redux'
import type { FormDelivery, OrderRestaurantShortDTO } from 'shared/types'

type ActionDeliveryPageDataResponse = {
    type: 'PAGE_DATA_DELIVERY_RESPONSE',
    data: State
}

type ActionDeliveryPageError = {
    type: 'DELIVERYPAGE_ERROR',
    error: any
}

type ActionDeliverySendEmailSuccess = {
    type: 'DELIVERY_SEND_EMAIL_SUCCESS'
}

type ActionDeliverySendEmailError = {
    type: 'DELIVERY_SEND_EMAIL_ERROR',
    sendEmailError: string
}

type ActionDeliverySendEmailReset = {
    type: 'DELIVERY_SEND_EMAIL_RESET'
}

type ActionSearchResults = {
    type: 'SEARCH_RESULTS',
    address?: string,
    geocodedAddress: Coordinates,
    restaurants: Array<OrderRestaurantShortDTO>,
    fromDelivery?: boolean
}

type ActionClearSearch = {
    type: 'CLEAR_SEARCH',
    fromDelivery?: boolean
}

const fetchDeliveryPageData = () =>
    fetchPageData(endpoints.pages.delivery, 'PAGE_DATA_DELIVERY_RESPONSE')

type ActionDeliveryPageReset = {
    type: 'DELIVERY_PAGE_RESET'
}

const actionError = (error: boolean): ActionDeliveryPageError => ({
    type: 'DELIVERYPAGE_ERROR',
    error
})

const sendDeliveryEmail = (form: FormDelivery) => {
    return async (dispatch: Dispatch<any>) => {
        try {
            await ws.post(endpoints.pages.delivery, form)
            dispatch(actionDeliverySendEmailSuccess())
        } catch (error) {
            const { response } = error
            console.error('Error sending delivery email', response)
            let message = 'form.error.default'
            dispatch(actionDeliverySendEmailError(message))
        }
    }
}

const sendDeliveryEmailReset = (): ActionDeliverySendEmailReset => ({
    type: 'DELIVERY_SEND_EMAIL_RESET'
})

const deliveryReset = (): ActionDeliveryPageReset => ({
    type: 'DELIVERY_PAGE_RESET'
})

const actionDeliverySendEmailSuccess = (): ActionDeliverySendEmailSuccess => ({
    type: 'DELIVERY_SEND_EMAIL_SUCCESS'
})

const actionDeliverySendEmailError = (
    sendEmailError: string
): ActionDeliverySendEmailError => ({
    type: 'DELIVERY_SEND_EMAIL_ERROR',
    sendEmailError
})

export {
    actionError,
    fetchDeliveryPageData,
    sendDeliveryEmail,
    deliveryReset,
    sendDeliveryEmailReset
}

export type Action =
    | ActionDeliveryPageDataResponse
    | ActionDeliveryPageError
    | ActionDeliverySendEmailSuccess
    | ActionDeliverySendEmailError
    | ActionDeliverySendEmailReset
    | ActionSearchResults
    | ActionClearSearch
    | ActionDeliveryPageReset
    | ActionsNetwork
